import { render, staticRenderFns } from "./MagazineDetail.vue?vue&type=template&id=a7a62696&scoped=true"
import script from "./MagazineDetail.vue?vue&type=script&lang=js"
export * from "./MagazineDetail.vue?vue&type=script&lang=js"
import style0 from "./MagazineDetail.vue?vue&type=style&index=0&id=a7a62696&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a62696",
  null
  
)

export default component.exports